import { ListPagination } from '@/components/list-pagination';

/** „1–25 von 80“. Null when the list is empty, so the empty-state sentence stays alone. */
function maintenanceListRangeLabel(page: number, pageSize: number, total: number): string | null {
  if (total <= 0 || pageSize <= 0) {
    return null;
  }
  const start = Math.min((Math.max(page, 1) - 1) * pageSize + 1, total);
  const end = Math.min(Math.max(page, 1) * pageSize, total);
  return `${start}–${end} von ${total}`;
}

export function MaintenanceListFooter({
  page,
  pageSize,
  total,
  onPageChange,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}) {
  const label = maintenanceListRangeLabel(page, pageSize, total);
  if (!label) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2 pt-2 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-sm text-muted-foreground">{label}</p>
      <ListPagination page={page} pageSize={pageSize} total={total} onPageChange={onPageChange} />
    </div>
  );
}
